import styled from 'styled-components';

export default styled.div`
  color: rgba(89, 89, 89, 1);
  position: relative;
  display: inline;
  font-size: 1.2rem;
  line-height: 2rem;
  text-align: left;
  margin-left: ${props => props.isRequired ? '1rem' : ''};
`;
